'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

require('scrolltofixed');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {
  $('[data-blog-menu-btn]').on('click', function () {
    $(_Dom2.default.blogMenu).addClass('active');
  });

  $('[data-close-blog-menu]').on('click', function () {
    $(_Dom2.default.blogMenu).removeClass('active');
  });

  $(_Dom2.default.blogNewsletter).on('submit', function (event) {
    event.preventDefault();
    var email = $(undefined).find('input').val();
    var brontoPixelSrc = 'http://app.bronto.com/public/?q=direct_add&fn=Public_DirectAddForm&id=bugdfkoneetzmqauhdkyeptcyopxbgj&email=' + email + '&createCookie=1&list1=0bd803ec00000000000000000000000a1d68';
    var brontoPixel = $('<img />', {
      src: brontoPixelSrc,
      width: 0,
      height: 0,
      border: 0,
      alt: ''
    });

    brontoPixel.appendTo('body');
    $(_Dom2.default.blogNewsletter).hide();
    $(_Dom2.default.blogSignupSuccess).show();
  });

  var blogFixedNav = function blogFixedNav() {
    var offset = $('.header-main').outerHeight();

    $(_Dom2.default.blogNav).scrollToFixed({
      marginTop: offset,
      zIndex: 6
    });
  };

  blogFixedNav();

  window.addEventListener('resize', function () {
    blogFixedNav();
  });
};

exports.default = {
  bindActions: bindActions
};